import Page from "../../components/Page/Page";
import {
  Row,
  Col,
  Input,
  Steps,
  message,
  Button,
  Modal,
  InputNumber,
  Form,
  Space,
  Select,
} from "antd";
import { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import CustomerGridItem from "../../components/CustomerGrid";
import ProductItem from "../../components/eCommerce/ProductItem";
import Classes from "./index.module.css";
import Widget from "../../components/Widget";
import FilteredTable from "../../components/table/filteredTable";
import CircularProgress from "../../components/CircularProgress";
import generateReceipt from "../../util/pdfExport/pdfRecipt";
import { GetWithExpiry } from "../../util/sessionManager";
import { pricify } from "../../util/textFormater";
import { GetProducts, GetProductGoroups } from "../../API/products";
import { GetCustomers } from "../../API/customer";
import { RegNewRequest, GetGifts } from "../../API/Request";
import { globalize } from "../../util/Handy/Inputs/numberOnly";
import { CalcDistance, giveLocation } from "../../util/GPS";
const Search = Input.Search;
const Step = Steps.Step;
const GetNumber = Modal.confirm;
const ErrorModal = Modal.error;
const FormItem = Form.Item;
const InputGroup = Input.Group;
const TeaxtArea = Input.TextArea;
const Option = Select.Option;
const fee = {
  1: "price1",
  2: "price2",
  3: "price3",
  4: "price4",
  5: "price5",
};
export default function Request() {
  const [currentPage, setCurrentPage] = useState({ current: 0 });
  const [customers, setCustomers] = useState(
    GetWithExpiry("customers")
      ? GetWithExpiry("customers").map((j) => {
          j.fee = fee[j.fee.toString()];
          j.btn = {
            title: "ثبت درخواست",
            action: () => {
              if (
                GetWithExpiry("user").distance[0] > 0 &&
                GetWithExpiry("user").distance[1] > 0
              ) {
                if (navigator.geolocation) {
                  navigator.geolocation.getCurrentPosition(
                    (position) => {
                      try {
                        const r = {
                          status: true,
                          latitude: position.coords.latitude,
                          longitude: position.coords.longitude,
                        };
                        // console.log("location", r);
                        // console.log("location", {
                        //   latitude: j.lat,
                        //   longitude: j.lng,
                        // });
                        const dist = CalcDistance(r, {
                          latitude: j.lat,
                          longitude: j.lng,
                        });

                        if (
                          GetWithExpiry("user").distance[0] > dist &&
                          GetWithExpiry("user").distance[1] > dist
                        ) {
                          const curr = currentPage.current + 1;
                          setCurrentPage({ current: curr });
                          const sCustomer = j;
                          sCustomer.btn = null;
                          sCustomer.open = false;
                          setSelectedCustomers(sCustomer);
                        } else {
                          message.error(
                            "فاصله شما تا مشتری بیش از حد مجاز است"
                          );
                        }
                      } catch (err) {
                        message.error(err.message);
                      }
                    },
                    (err) => {
                      message.error(err.message);
                    }
                  );
                } else {
                  message.error("دسترسی به موقعیت مکانی وجود ندارد");
                }
              } else {
                const curr = currentPage.current + 1;
                setCurrentPage({ current: curr });
                const sCustomer = j;
                sCustomer.btn = null;
                sCustomer.open = false;
                setSelectedCustomers(sCustomer);
              }
            },
          };
          return j;
        })
      : []
  );
  const [displayedCustomers, setDisplayedCustomers] = useState(customers);
  const [selectedCustomers, setSelectedCustomers] = useState();
  const [seletecdProduct, setSelectedProduct] = useState([]);
  const [products, setProducts] = useState(
    GetWithExpiry("products") ? GetWithExpiry("products") : []
  );
  const [displayedProduct, setDisplayedProduct] = useState(products);
  const [date, setDate] = useState(new Date().toLocaleDateString("fa-IR"));
  const [customersLoading, setCustomersLoading] = useState(false);
  const [itemsLoading, setItemsLoading] = useState(false);
  const [secondPageBtnLoading, setSecondPageBtnLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [off, setOff] = useState(0);
  
  const [searchGroups, setSearchGroups] = useState(
    GetWithExpiry("productGroups") ? GetWithExpiry("productGroups") : []
  );
  const [rewards, setRewards] = useState(
    GetWithExpiry("gifts") ? GetWithExpiry("gifts") : []
  );
  const [groups, setGroups] = useState([]);
  const [searchItemGroup, setSearchItemGroup] = useState("*");
  const [comment, setComment] = useState("");
  const [offType, setOffType] = useState(0);
  const history = useHistory();

  useEffect(() => {
    if (!customers.length) {
      setCustomersLoading(true);
      GetCustomers()
        .then((i) => {
          if (i.success) {
            const newCustomers = GetWithExpiry("customers").map((j) => {
              j.fee = fee[j.fee.toString()];
              j.btn = {
                title: "ثبت درخواست",
                action: () => {
                  const curr = currentPage.current + 1;
                  setCurrentPage({ current: curr });
                  const sCustomer = j;
                  sCustomer.btn = null;
                  sCustomer.open = false;
                  setSelectedCustomers(sCustomer);
                },
              };
              return j;
            });
            console.log(newCustomers);
            setCustomers(newCustomers);
            setDisplayedCustomers(newCustomers);
          }
        })
        .finally(() => {
          setCustomersLoading(false);
        })
        .catch((i) => {
          ErrorModal({
            title: "خطا",
            content: "مشکلی هنگان انجام عمیلات رخداد" + i,
            okText: "باشد",
            okType: "danger",
            onOk() {},
          });
        });
    }
  }, []);
  useEffect(() => {
    if (!products.length) {
      setItemsLoading(true);
      GetProducts()
        .then((i) => {
          if (i.success) {
            setProducts(GetWithExpiry("products"));
          }
        })
        .finally(() => {
          setItemsLoading(false);
        })
        .catch((i) => {
          ErrorModal({
            title: "خطا",
            content: "مشکلی هنگان انجام عمیلات رخداد" + i,
            okText: "باشد",
            okType: "danger",
            onOk() {},
          });
        });
    }
  }, []);

  useEffect(() => {
    setDisplayedProduct(products);
  }, [products]);
  useEffect(() => {
    if (!groups.length) {
      setItemsLoading(true);
      GetProductGoroups()
        .then((i) => {
          if (i.success) {
            setGroups(GetWithExpiry("productGroups"));
          }
          console.log(i);
        })
        .finally(() => {
          setItemsLoading(false);
        })
        .catch((i) => {
          ErrorModal({
            title: "خطا",
            content: "مشکلی هنگام دریافت گروه ها" + i,
            okText: "باشد",
            okType: "danger",
            onOk() {},
          });
        });
    }
  }, [groups]);
  function pad2(n) {
    return (n < 10 ? "0" : "") + n;
  }
  const onChangeHandler = (value) => {
    setSearchItemGroup(value);
  };
  function submitRequest() {
    setSubmitLoading(true);
    const d = new Date();
    const newD = globalize(
      date
        .split("/")
        .map((i) => {
          return i.toString().length > 1 ? i : "0" + i;
        })
        .join("/")
    );
    console.log("off", off);
    RegNewRequest({
      code_hesab: selectedCustomers.code_hesab,
      products: seletecdProduct,
      date: newD,
      discount: off,
      comment_visitor: "",
      shom_Invoice:
        JSON.parse(localStorage.getItem("activeLine")).code.toString() +
        GetWithExpiry("user").code.toString() +
        (d.getFullYear() + pad2(d.getMonth()) + pad2(d.getDate())).replace(
          "/",
          ""
        ) +
        (pad2(d.getHours()).toString() +
          pad2(d.getMinutes()).toString() +
          pad2(d.getSeconds()).toString()),
    })
      .then((i) => {
        console.log("response", i);

        if (i.success) {
          message.success("درخواست شما ثبت شد!");
          generateReceipt(
            seletecdProduct.map((i) => {
              return {
                name: i.nameItem,
                quantity: i.count,
                price: i.fee,
                tax: i.tax
              };
            }),
            selectedCustomers,
            off
          );
          setCustomers();
          setOff(0);
          setSelectedProduct([]);
          const curr = currentPage.current - 2;
          setCurrentPage({ current: curr });
        } else {
          message.error("عملیات با مشکل رو به رو شد");
        }
      })
      .finally(() => {
        setSubmitLoading(false);
      })
      .catch((e) => {
        ErrorModal({
          title: "خطا",
          content: "مشکلی هنگان انجام عمیلات رخداد" + e,
          okText: "باشد",
          okType: "danger",
          onOk() {},
        });
      });
  }
  const onSearchProduct = (value, _e, info) => {
    setDisplayedProduct(
      products.filter((i) => {
        if (searchItemGroup != "*") {
          if (
            (i.name.toString().includes(value) ||
              i.id.toString().includes(value)) &&
            i.group.includes(searchItemGroup)
          ) {
            return i;
          }
        } else if (value == "" && searchItemGroup == "*") {
          return i;
        } else {
          if (
            i.name.toString().includes(value) ||
            i.id.toString().includes(value)
          ) {
            return i;
          }
        }
      })
    );
  };
  const onSearch = (value, _e, info) => {
    setDisplayedCustomers(
      customers.filter((i) => {
        if (
          i.name.toString().includes(value) ||
          i.id.toString().includes(value) ||
          i.address.toString().includes(value)
        ) {
          return i;
        }
      })
    );
  };
  const onRemove = (id) => {
    setSelectedProduct((prevProducts) =>
      prevProducts.filter((i) => i.id !== id)
    );
  };
  const addToCart = (id, name, max1, max2) => {
    let countRef = 0;
    let pacRef = 0;
    GetNumber({
      title: name,
      content: (
        <>
          <Col lg={24} md={24} sm={24} style={{ direction: "rtl" }}>
            <Col lg={24} md={24} sm={24}>
              <FormItem
                label="بسته:"
                style={{ width: "100%" }}
                wrapperCol={18}
              >
                <InputNumber
                  onChange={(e) => {
                    countRef = e;
                  }}
                  min={0}
                  max={max1}
                  step={1}
                />
              </FormItem>
            </Col>
            <Col lg={24} md={24} sm={24}>
              <FormItem label="جزء:" style={{ width: "100%" }}>
                <InputNumber
                  onChange={(e) => {
                    pacRef = e;
                  }}
                  min={0}
                  max={max2}
                  step={1}
                />
              </FormItem>
            </Col>
          </Col>
        </>
      ),
      okText: "تایید",
      onOk: () => {
        const wasSelected = seletecdProduct.filter((i) => i.id === id);
        if (wasSelected.length) {
          wasSelected.pac = pacRef;
          wasSelected.count = countRef;
          setSelectedProduct([
            ...seletecdProduct.filter((i) => i.id === id),
            ...wasSelected,
          ]);
        } else {
          if (pacRef > 0 || countRef > 0) {
            const newSelect = products.filter((i) => i.id === id);
            console.log(newSelect[0], selectedCustomers.fee);
            setSelectedProduct([
              ...seletecdProduct,
              {
                id: id,
                nameItem: newSelect[0].name,
                pac: pacRef,
                count: countRef,
                fee: newSelect[0][selectedCustomers.fee],
                offRow: 0,
                avarez: 0,
                tax: newSelect[0].tax? (newSelect[0][selectedCustomers.fee]/100)*newSelect[0].tax:0,
                giftRow: 0,
                rebateGift: "",
              },
            ]);
          } else {
            const newSelect = products.filter((i) => i.id !== id);
            setSelectedProduct([...newSelect]);
          }
        }
      },
      cancelText: "لغو",
    });
  };
  const getingReady = () => {
    setSecondPageBtnLoading(true);
    GetGifts({ products: seletecdProduct })
      .then((i) => {
        if (i.success) {
          console.log(i.data.type);
          console.log(i.data.data);
          switch (i.data.type) {
            case 1:
              setSelectedProduct([...seletecdProduct, ...i.data.data]);
              break;
            case 2:
              i.data.data.forEach((item, index) => {
                const p = seletecdProduct.filter((j) => j.id == item.id);

                if (p.length) {
                  setOff(
                    off +
                      ((p[0].fee * p[0].count) / 100) * item.percent +
                      item.price
                  );
                }
              });
              break;
            case 3:
              i.data.data.forEach((item, index) => {
                const p = seletecdProduct.filter((j) => j.id === item.id);

                if (p.length) {
                  setOff(
                    off +
                      ((p[0].fee * p[0].count) / 100) * item.percent +
                      item.price
                  );
                  console.log(546486);
                }
              });
              break;
            case 4:
              setSelectedProduct([...seletecdProduct, ...i.data.data]);
              break;
          }
        }
      })
      .finally(() => {
        setSecondPageBtnLoading(false);
        const curr = currentPage.current + 1;
        setCurrentPage({ current: curr });
      })
      .catch((e) => {
        message.error("دریافت جوایز با مشکل برخورد");
        console.error(new Error(e));
      });
  };
  const prev = () => {
    const curr = currentPage.current - 1;
    setCurrentPage({ current: curr });
  };
  const invoiceColumn = [
    {
      title: "شرح کالا",
      dataIndex: "nameItem",
      key: "nameItem",
      search: true,
    },
    {
      title: "تعداد",
      dataIndex: "count",
      key: "count",
      search: true,
    },
    {
      title: "فی",
      dataIndex: "fee",
      key: "fee",
      search: true,
      render: (text, record) => <span>{pricify(record.fee.toString())}</span>,
    },
    {
      title: "ارزش افزوده",
      dataIndex: "tax",
      key: "tax",
      search: true,
      render: (text, record) => <span>{pricify(record.tax.toString())}</span>,
    },
    {
      title: "قیمت",
      dataIndex: "price",
      key: "price",
      render: (text, record) => (
        <span>{pricify((record.count * record.fee).toString())}</span>
      ),
      search: true,
    },
    {
      title: "حذف",
      dataIndex: "remove",
      key: "remove",
      render: (text, record) => (
        <Button type="ghost" style={{borderWidth:0,backgroundColor: "#ffffff"}} onClick={()=>{onRemove(record.id)}}>حذف</Button>
      ),
      search: true,
    },
  ];

  const steps = [
    {
      key: 1,
      title: "مشتری",
      content: (
        <>
          <Row className={Classes.searchForm}>
            <Search
              placeholder="جستوجو نام و کد و آدرس"
              onSearch={onSearch}
              allowClear
              enterButton
            />
          </Row>

          {customersLoading && <CircularProgress />}
          <Row>
            {displayedCustomers.map((i) => {
              return (
                <Col span={24} key={i.id}>
                  <CustomerGridItem {...i} />
                </Col>
              );
            })}
          </Row>
        </>
      ),
    },
    {
      key: 2,
      title: "کالا",
      content: (
        <>
          <Row className={Classes.searchForm}>
            <Widget styleName={Classes.sertformInputs}>
              <Form.Item>
                <Select
                  showSearch
                  defaultValue={"*"}
                  onChange={onChangeHandler}
                >
                  <Select.Option value={"*"}>همه</Select.Option>
                  {groups.map((i) => (
                    <Select.Option value={i.code}>{i.name}</Select.Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item>
                <Search
                  placeholder="جستوجو نام و کد"
                  onSearch={onSearchProduct}
                  allowClear
                  enterButton
                />
              </Form.Item>
            </Widget>
            <Space size={270}>
              <Button
                type="default"
                className={Classes.nextBtn}
                shape="circle"
                size="large"
                loading={secondPageBtnLoading}
                onClick={() => {
                  const curr = currentPage.current - 1;
                  setCurrentPage({ current: curr });
                }}
              >
                <i className="fa-solid fa-arrow-right" />
              </Button>
              <Button
                type="primary"
                className={Classes.nextBtn}
                shape="circle"
                size="large"
                disabled={itemsLoading}
                loading={secondPageBtnLoading}
                onClick={getingReady}
              >
                <i className="fa-solid fa-cart-shopping" />
              </Button>
            </Space>
          </Row>
          <Row>
            {itemsLoading && <CircularProgress />}
            {displayedProduct.length && !itemsLoading
              ? displayedProduct.map((product, index) => (
                  <Col key={index} span={24}>
                    <ProductItem
                      key={index}
                      product={product}
                      btn={{
                        btnTitle: "افزودن به سبد خرید",
                        btnAction: addToCart,
                      }}
                      priviliges={JSON.parse(localStorage.getItem("privilage"))}
                    />
                  </Col>
                ))
              : ""}
          </Row>
        </>
      ),
    },
    {
      key: 3,
      title: "ثبت",
      content: (
        <>
          <Row className={Classes.searchForm}>
            <Space size={270}>
              <Button
                type="default"
                shape="circle"
                size="large"
                onClick={() => {
                  const curr = currentPage.current - 1;
                  setCurrentPage({ current: curr });
                }}
                loading={submitLoading}
              >
                <i className="fa-solid fa-arrow-right" />
              </Button>
              <Button
                type="primary"
                className={Classes.nextBtn}
                shape="circle"
                size="large"
                onClick={submitRequest}
                loading={submitLoading}
              >
                <i className="fa-solid fa-arrow-up-from-bracket" />
              </Button>
            </Space>
          </Row>

          <Row>
            <Col span={16}>
              <CustomerGridItem {...selectedCustomers} />
            </Col>
            <Col span={8}>
              <Widget styleName={Classes.selectedCustomerView}>{date}</Widget>
            </Col>
          </Row>

          <Row style={{overflowX:"auto"}}>
          <FilteredTable  data={seletecdProduct} headers={invoiceColumn} />
          </Row>
          <Widget>
            {/* <Col lg={24} md={24} sm={24} className="gx-mb-3">
              <FormItem
                disabled
                label="نوع تخفیف"
                labelCol={{ span: 6 }}
                wrapperCol={{ span: 18 }}
              >
                <Select
                  defaultValue={0}
                  onChange={(e) => {
                    setOffType(e);
                  }}
                >
                  <Option value={0}>ريال</Option>
                  <Option value={1}>درصد</Option>
                </Select>
              </FormItem>
            </Col> */}
            <Col lg={24} md={24} sm={24} className="gx-mb-3">
              <FormItem
                label="تخفیف"
                labelCol={{ span: 6 }}
                wrapperCol={{ span: 18 }}
              >
                <InputNumber
                  value={off}
                  onChange={(e) => {
                    if (e === null && off === 0) {
                      setOff(0);
                    } else if (
                      e >
                      seletecdProduct
                        .map((i) => {
                          return i.count * i.fee;
                        })
                        .reduce((a, b) => a + b, 0)
                    ) {
                      setOff(
                        seletecdProduct
                          .map((i) => {
                            return i.count * i.fee;
                          })
                          .reduce((a, b) => a + b, 0)
                      );
                    } else {
                      setOff(e);
                    }
                  }}
                  style={{ width: "100%" }}
                  min={0}
                  defaultValue={0}
                  max={
                    offType
                      ? 100
                      : seletecdProduct
                          .map((i) => {
                            return i.count * i.fee;
                          })
                          .reduce((a, b) => a + b, 0)
                  }
                />
              </FormItem>
            </Col>
            <Col lg={24} md={24} sm={24} className="gx-mb-3">
              <FormItem
                label="توضیحات"
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
              >
                <TeaxtArea
                  onChange={(v) => {
                    setComment(v);
                  }}
                />
              </FormItem>
            </Col>
          </Widget>
          <Widget>
            <div className={Classes.finalPriceTitle}>ارزش افزوده:</div>
            <div className={Classes.finalPrice}>{pricify(
                (
                  seletecdProduct
                    .map((i) => {
                      return i.tax;
                    })
                    .reduce((a, b) => a + b, 0) - parseInt(off)
                ).toString()
              )}</div>
          </Widget>
          <Widget styleName={Classes.bottomPrice}>
            <div className={Classes.finalPriceTitle}>جمع نهایی:</div>
            <div className={Classes.finalPrice}>
              {pricify(
                (
                  seletecdProduct
                    .map((i) => {
                      return (i.count * i.fee)+i.tax;
                    })
                    .reduce((a, b) => a + b, 0) - parseInt(off)
                ).toString()
              )}
            </div>
          </Widget>
        </>
      ),
    },
  ];
  return (
    <>
      <>
        <Steps
          direction="horizontal"
          style={{ flexDirection: "row" }}
          {...currentPage}
        >
          {/* {steps.map((item) => (
            <Step key={item.title} />
          ))} */}
          <Step key={1} />
          <Step key={2} />
          <Step key={3} />
        </Steps>
        <div className="steps-content">
          {steps[currentPage.current].content}
        </div>
        <div className="steps-action"></div>
      </>
    </>
  );
}
